/**
 * Feature Flags Configuration
 *
 * Centralized feature flag management for the application.
 * Feature flags can be toggled via environment variables for easy control.
 */

/**
 * Check if a feature flag is enabled
 * @param {string} flagName - The name of the feature flag environment variable
 * @returns {boolean} - True if the feature is enabled, false otherwise
 */
const isFeatureEnabled = (flagName) => {
  const value = process.env[flagName];
  return value === 'true';
};

/**
 * Feature Flags
 */
export const FeatureFlags = {
  // Slack User Import - Controls visibility of Slack bulk user import functionality
  // Set REACT_APP_FEATURE_SLACK_USER_IMPORT=true to enable
  SLACK_USER_IMPORT: isFeatureEnabled('REACT_APP_FEATURE_SLACK_USER_IMPORT'),
};

/**
 * Helper function to check if a specific feature is enabled
 * @param {string} featureName - The name of the feature from FeatureFlags object
 * @returns {boolean}
 */
export const isEnabled = (featureName) => {
  return FeatureFlags[featureName] || false;
};

export default FeatureFlags;
